<template>
  <div class="tab-six-cv">
    <div>
      <el-form class="form-wrapper" label-width="80px">
        <el-form-item label="状态">
          <el-select
            v-model="local_filter_state"
            multiple
            collapse-tags
            placeholder="请选择(支持多选)"
          >
            <el-option
              v-for="item in kStateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          @click="filterAction"
          style="margin-left: 10px"
          type="primary"
          >筛选</el-button
        >
      </el-form>
      <el-alert title="" type="error" >
        <div style="font-size: 18px;line-height: 26px">
          Your CV should list your education to date, your work experience (including voluntary
          work where relevant), and any publications you have. Include a brief summary of the
          duties each post entailed, but please keep your CV concise and factual - ie., give dates
          and place of employment rather than describing the skills you have acquired.
        </div>
      </el-alert>
      <el-table v-loading="loading" :data="lists" style="width: 100%">
        <el-table-column prop="d1" label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{
              (requestData.page - 1) * requestData.paginate + (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center" />

        <el-table-column prop="" label="写作构思" align="center">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.writing_conception"
              type="primary"
              @click="detailInfoDialog = scope.row.writing_conception"
              >查看</el-link
            >
            <p v-else>--</p>
          </template>
        </el-table-column>
        <el-table-column label="文书" prop="" align="center">
          <template slot-scope="scope">
            <!-- <el-link type="primary" @click="downLoad(scope.row.upload_documents[0].url,scope.row.upload_documents[0].name)">下载</el-link> -->
            <div v-if="scope.row.name">
              <el-link
                type="primary"
                @click="
                  () => {
                    previewUrl = scope.row.upload_documents[0].url;
                    previewName = scope.row.upload_documents[0].name;
                  }
                "
              >
                预览/下载
              </el-link>
              <p v-if="scope.row.document_status == 1" style="color: red;margin: 0"
              >[终稿]</p
              >
              <p v-if="scope.row.document_status == 2" style="color: red;margin: 0"
              >[草稿,请勿确认]</p
              >
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="文书记录" prop="" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="logDocumentCV(scope.row)"
              >查看</el-link
            >
          </template>
        </el-table-column> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status == 3" style="color: #f56c6c">
              待确认
            </p>
            <p v-if="scope.row.status == 1" style="color: #08a0eeff">已确认</p>
            <el-link
              v-if="scope.row.status == 2"
              type="danger"
              @click="reasonRejectionUserSchoolChoice(scope.row.content,scope.row.reject_type)"
              >已驳回，待老师修改</el-link
            >
            <p v-if="scope.row.status == 0" style="color: #f56c6c">
              待老师上传
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="" align="center">
          <template slot-scope="scope">
            <div class="btns-wrapper">
              <el-popconfirm
                class="btn"
                title="是否确认？"
                @confirm="updateStatus(scope.row.id, 1)"
                v-if="scope.row.status == 3"
              >
                <el-button slot="reference" size="mini" type="primary"
                  >确认</el-button
                >
              </el-popconfirm>
              <el-button
                v-if="scope.row.status == 3"
                size="mini"
                type="danger"
                class="btn"
                @click="refuseUserSchoolChoice(scope.row.id)"
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" align="center" />
      </el-table>
    </div>

    <!--文书上传弹窗-->
    <show_document ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="getList" />
    <reject ref="reject" @reject="getList" :needFile="true"></reject>
    <reason_rejection ref="reason_rejection"></reason_rejection>
    <HBFilePreview
      :previewUrl="previewUrl"
      :fileName="previewName"
      @updateVisible="
        previewUrl = null;
        previewName = null;
      "
    />
    <el-dialog
      center
      title="查看"
      :visible="detailInfoDialog"
      width="50%"
      :before-close="() => (detailInfoDialog = null)"
    >
      <p style="white-space: pre-wrap; font-size: 16px">
        {{ detailInfoDialog }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  document_list,
  del_document,
  user_information_document_edit,
} from "@/api/mycenter_studyabroad";
import show_document from "./show_document";
import upload_document from "./upload_document";
import reject from "./reject";
import { downloadFile } from "@/api/file";
import reason_rejection from "./reason_rejection.vue";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview";
export default {
  name: "TabSixCv",
  components: {
    show_document,
    upload_document,
    reject,
    reason_rejection,
    HBFilePreview,
  },
  data() {
    return {
      local_filter_state: [],
      detailInfoDialog: null,
      previewUrl: null,
      previewName: null,
      refuseId: "", // 驳回id
      reason: "", // 拒绝理由
      dialogAddUserSchoolChoice: false,
      dataSource: [],
      lists: [], // 数据列表
      addUserSchoolChoiceData: {
        remark: "",
      },
      requestData: {
        page: 1, // 当前页
        paginate: 15, // 分页大小
        templates_id: "",
        type: "cv",
        loading: "",
      },
      content: {
        title: "",
        type: "",
        name: "",
        operate: "",
        id: "",
      },
    };
  },
  computed: {
    kStateOptions() {
      return [
        {
          label: "已驳回",
          value: 2,
        },
        {
          label: "待确认",
          value: 3,
        },
        {
          label: "已确认",
          value: 1,
        },
        {
          label: "待老师上传",
          value: 0,
        },
      ];
    },
  },
  created() {
    this.getList(true);
  },
  methods: {
    filterAction() {
      if (!this.local_filter_state || this.local_filter_state.length == 0) {
        this.lists = this.dataSource;
        return;
      }
      const resultList = [];
      const stateList = this.local_filter_state || [];

      this.dataSource.forEach((item) => {
        var flag = true;

        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item);
        }
      });
      this.lists = resultList;
    },
    downLoad(url, name) {
      downloadFile(url, name);
    },
    refuseUserSchoolChoice(id) {
      this.$refs.reject.sendItem(id, "cv", 2);
    },
    updateStatus(id, status) {
      var reason = this.reason;
      user_information_document_edit({
        id: id,
        con: reason,
        status: status,
        type: "cv",
      }).then((response) => {
        this.dialogAddUserSchoolChoice = false;
        this.getList();
      });
    },
    reasonRejectionUserSchoolChoice(content,reject_type) {
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url,reject_type);
    },
    getList(isRefresh) {
      this.loading = true;
      document_list(this.requestData)
        .then((response) => {
          this.loading = false;
          const dataList = response.data || [];
          this.dataSource = dataList;
          this.lists = dataList;
          this.filterAction();
        })
        .catch((error) => {});
    },
    addDocumentCV() {
      this.content.type = "cv";
      this.content.operate = "add";
      this.content.title = "添加cv";
      this.content.id = "";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    editDocumentCV(content) {
      this.content.type = "cv";
      this.content.id = content.id;
      this.content.name = content.name.substring(0, content.name.indexOf("-"));
      this.content.operate = "edit";
      this.content.title = "修改cv";
      this.$refs.uploadDocument.sendItem(this.content);
    },

    logDocumentCV(content) {
      this.$refs.showDocument.sendItem(content.upload_documents);
    },
    delDocumentCV(id) {
      del_document({ id: id, type: "cv" }).then((response) => {
        this.getList(true);
      });
    },
    handleSizeChange(val) {
      this.requestData.paginate = val;
      this.getList(false);
    },
    handleCurrentChange(val) {
      this.requestData.page = val;
      this.getList(false);
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-six-cv {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six_cv.vue